import { LayoutBlock } from '@/layout';
import { RouteConfig } from 'vue-router';

const CustomizeReportRouting: RouteConfig[] = [
    {
        name: 'customize-report',
        path: 'customize-report',
        meta: { title: '自定义报表' },
        component: LayoutBlock,
        children: [
            {
                name: 'customize-report-index',
                path: '',
                component: () => import('./customize-report.vue'),
                meta: { title: '自定义报表' },
            },
        ],
    },
];

export default CustomizeReportRouting;
